import { useMemo, useRef } from 'react';

import { LogoPlaceholder } from 'icons';

import { useScrollText } from '../../hooks/useScrollText';
import { TOption } from './Dropdown';
import { DropdownItem } from './DropdownItem';

const DefaultOption = ({
  option,
  selected,
  preselected,
}: {
  option?: TOption;
  selected?: boolean;
  preselected?: boolean;
}) => {
  const textBoxRef = useRef<HTMLDivElement>(null);
  const triggerBoxRef = useRef<HTMLDivElement>(null);

  useScrollText(textBoxRef, triggerBoxRef);

  const iconToUse = useMemo(() => {
    if (typeof option?.icon === 'string') {
      return (
        <img src={option.icon || LogoPlaceholder} alt="icon" loading="lazy" decoding="async" />
      );
    }
    return option?.icon;
  }, [option?.icon]);

  return (
    <div className="group" ref={triggerBoxRef}>
      <DropdownItem
        className={preselected && !selected ? 'bg-v2blueGray-200/40' : ''}
        icon={iconToUse}
        selected={selected}
        disabled={option?.disabled}
      >
        <div ref={textBoxRef} className="whitespace-nowrap truncate w-full">
          <span className="group-hover:inline-block">{option?.label}</span>
        </div>
      </DropdownItem>
    </div>
  );
};

export { DefaultOption };
